import { useContext, useEffect, useState } from "react";
import { getPageOfTenBlogs, dynamicResourceLinks, useGoto, isAdmin, jsonParseUTF, bestFittingImage } from "./util";
import { useSearchParams } from "react-router-dom";
import LoadingBlog from "./LoadingBlogs";
import ControlPannel from "./ControlPannel";
import CustomLink from "./CustomLink";
import $ from 'jquery'
import placeholderimage from './placeholderimage.png'
import { globalContext } from "./App";

const Blogs = () => {
	const { setGlobalBlogs } = useContext(globalContext)
	const [pages, setPages] = useState(<></>);
	console.log("rendered blogs")
	let params = useSearchParams()[0];
	var searchquery = params.get("name")
	var qpagenum = params.get("page");
	const [pagenum, setPagenum] = useState(qpagenum && !isNaN(qpagenum) ? String(qpagenum) : "1");
	// var pagenum = "1";
	// if (qpagenum && !isNaN(qpagenum)) {
	// 	pagenum = String(qpagenum);
	// }
	var searchstring = ""
	if (searchquery) {
		searchstring = 'Results for "' + searchquery + '" :'
	}
	const [blogs, setBlogs] = useState(
		<>
			<LoadingBlog></LoadingBlog>
			<LoadingBlog></LoadingBlog>
			<LoadingBlog></LoadingBlog>
		</>
	);
	// useEffect(() => {
	// 	return () => {
	// 		setPreviewBlog(null);
	// 	}
	// }, [setPreviewBlog])
	useEffect(() => {
		getPageOfTenBlogs(pagenum, searchquery).then((response) => {
			setPages(Array.from({length: 3}, (_, i) => Number(pagenum) + i - 1).map(num =>
				<CustomLink className={"pcbangbutton pagebutton" + (String(pagenum) === String(num) ? " current" : "") + (num < 1 || num > response.data.meta.pagination.pageCount ? " invalid" : "")} to={"/blogs?page=" + num + (searchquery ? "&name=" + searchquery : "")} onClick={() => { setPagenum(num)}}>
					{num}
				</CustomLink>
			))
			setGlobalBlogs(JSON.stringify(response.data.data))
			var content
			var list = response.data.data
			// list = list.filter(block => !searchquery || block.attributes.title.toLowerCase().includes(searchquery.toLowerCase()))
			// const half = Math.ceil(list.length / 2);
			// const firstHalf = list.splice(0, half)
			// const secondHalf = list.splice(-half)
			const firstHalf = list.filter((el, index) => index % 2 === 0)
			const secondHalf = list.filter((el, index) => index % 2)
			// if (secondHalf.length === 0) {
			// 	secondHalf.append(<div style=></div>)
			// }
			var fapply = block => {
				var blog = block.attributes
				try {
					var authorAvatar, authorName, blogImage
					var avatar, image, author
					author = blog.author?.data?.attributes
					avatar = author?.avatar?.data?.attributes
					image = blog?.image?.data?.attributes
					// console.log({author,avatar,image})
					authorAvatar = bestFittingImage(avatar?.formats, avatar, {width: 20, height: 20})
					authorName = author?.name /**/ ? author.name : "unknown"
					blogImage = bestFittingImage(image?.formats, image, {width: 300, height: 300}, placeholderimage)
					
					return (
						<div className={blog.slug + " blog blog-card"} key={block.id}>
							<CustomLink onClick={() => { $('html,body').scrollTop(0); }} className={"blog " + blog.slug} to={"/blogs/" + blog.slug}>
								<img
									loading="lazy"
									src={blogImage}
									alt="" className="blog-image" />
								<h1 className="blog-title">{jsonParseUTF(blog.title)}</h1>
								<div className="info" style={{ flexShrink: 0 }}>
									<div
										// src="https://api.pcbang.ma"
										style={{ backgroundImage: `url(${authorAvatar})`, backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "50% 50%", border: "none" }}
										alt="" className="author" />
									<p className="text" style={{ textTransform: "uppercase", color: "#dfdfdf" }}>
										{
											(() => {
												var date = new Date(blog.publishedAt)
												return (
													<>
														{authorName + " · " + date.toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric' })}
													</>
												)
											})()
										}
									</p>
								</div>
							</CustomLink>
						</div>
					);
				}
				catch (error) {
					console.log(error)
					return <div key={block.id} style={{ display: "none" }}>error: {error.toString()}<br></br>on blog: {JSON.stringify(blog)}</div>
				}
			}
			content = <>
				<div className="halves left">
					{firstHalf.map(fapply)}
				</div>
				<div className="halves right">
					{secondHalf.map(fapply)}
				</div>
				<div className="halves hidden">
					{list.map(fapply)}
				</div>
			</>
			setBlogs(content)
		}).catch(err => {
			// console.clear()
			console.log(err)
			setBlogs(<>
				<div className="error">{err.toString()}</div>
			</>)
		})
	}, [searchquery, setGlobalBlogs, pagenum])
	var gtl = useGoto("/login")
	return (
		<div className="pagebody blogs">
			<div className="mainbody">
				<div className="navpad">
					<div className="hiddeloginbutton"
						style={{ width: "10px", height: "10px", cursor: "pointer", backgroundColor: "rgba(255,255,255,0.1)" }}
						onClick={gtl}
					></div>
				</div>
				<ControlPannel >
					{
						isAdmin()
							?
							<CustomLink className="users left"
								to={"/users"}
							>
								<img src={dynamicResourceLinks("ff09ff").userIcon} alt="" className="icon" />
								<div className="tooltip">
									manage users
								</div>
							</CustomLink>
							:
							<div></div>
					}
					<CustomLink className="newblog right"
						to={"/create-new-blog"}
					>
						<div className="plus">+</div>
						<div className="tooltip">
							create new blog
						</div>
					</CustomLink>
				</ControlPannel>
				{
					searchquery ?
						<>
							<div className="searchquery">{searchstring}</div>
							<div className="navpad"></div>
						</> :
						<></>
				}
				<div className="blogscontainer actualblogs" style={{ flexDirection: "row", flexWrap: "wrap", gap: "50px" }}>
					{blogs}
				</div>
				<div className="pagenum">
					<div className="container flex-gap10">
						{/* <div className="left">{"<<"} 5</div> */}
						<div className="middle flex-gap10">
							{
								pages
							}
						</div>
						{/* <div className="right">5 {">>"}</div> */}
					</div>
				</div>
			</div>
		</div>
	);
}

export default Blogs;